<template>
  <div class="app" >

    <v-card>
      <v-layout row wrap>
        <v-flex xs6 >
          <v-card-title>
            <v-chip text-color="white" label color="primary">
              LISTE DES DEMANDES A VALIDER <v-icon right>assignment</v-icon>
            </v-chip>
            <v-spacer></v-spacer>
            <v-text-field append-icon="search" label="Recherche" single-line hide-details v-model="searchRequest"></v-text-field>
          </v-card-title>
          <v-data-table v-bind:headers="headersRequestValid" v-bind:search="searchRequest" v-bind:pagination.sync="paginationRequestValid" :items="listRequestValid" hide-actions class="elevation-1">
           <template slot="items" scope="props">
             <td class="text-xs-center">{{ props.item.numero }}</td>
             <td class="text-xs-center">{{ props.item.nomDemandeur }}</td>
             <td class="text-xs-center">{{ props.item.created }}</td>
             <td class="text-xs-center">
                <div class="text-xs-center">
                  <v-tooltip top>
                    <v-btn slot="activator" @click.stop="validRequest(props.item)" fab dark small color="blue">
                      <v-icon dark>done</v-icon>
                    </v-btn>
                    Valider
                  </v-tooltip>
                </div>
              </td>
           </template>
         </v-data-table>
         <div class="text-xs-center pt-2">
           <v-pagination v-model="paginationRequestValid.page" :length="pagesRequest"></v-pagination>
         </div>
        </v-flex>
        <v-flex xs6 >
          <v-card-title>
            <v-chip text-color="white" label color="primary">
              LISTE DES DEVIS A VALIDER <v-icon right>assignment</v-icon>
            </v-chip>
            <v-spacer></v-spacer>
            <v-text-field append-icon="search" label="Recherche" single-line hide-details v-model="searchDevis"></v-text-field>
          </v-card-title>
          <v-data-table v-bind:headers="headersDevisValid" v-bind:search="searchDevis" v-bind:pagination.sync="paginationDevisValid" :items="listDevisValid" hide-actions class="elevation-1">
           <template slot="items" scope="props">
             <td class="text-xs-center">{{ props.item.numero }}</td>
             <td class="text-xs-center">{{ props.item.nomDemandeur }}</td>
             <td class="text-xs-center">{{ props.item.created }}</td>
             <td class="text-xs-center">
                <div class="text-xs-center">
                  <v-tooltip top>
                    <v-btn slot="activator" @click.stop="validDevis(props.item)" fab dark small color="blue">
                      <v-icon dark>edit</v-icon>
                    </v-btn>
                    Modifier
                  </v-tooltip>
                </div>
              </td>
           </template>
         </v-data-table>
         <div class="text-xs-center pt-2">
           <v-pagination v-model="paginationDevisValid.page" :length="pagesDevis"></v-pagination>
         </div>
        </v-flex>
      </v-layout> 
    </v-card>

    <!-- MODAL VALIDATION -->
    <v-dialog v-model="modalValidation" max-width="50%" :overlay="true" scrollable persistent>
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue">
          <v-toolbar-title>
            <span>Alerte !!!</span> 
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="modalValidation = false" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>

        <v-card-text>

          <p align="center">
            <v-btn flat color="blue darken-1" @click.stop="accepterDemande" large>Accepter</v-btn>
            <v-btn flat color="red" @click="refuserDemande" large>Refuser</v-btn>
          </p>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
  export default {
    name: 'app',
    data () {
      return {
        loading: false,
        domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
        user: JSON.parse(sessionStorage.getItem('userInfo')),
        headersRequestValid: [
          { text: 'Numero', align: 'center', sortable: true, value: '' },
          { text: 'Demandeur', align: 'center', value: '' },
          { text: 'Date', align: 'center', value: '' },
          { text: 'Actions', align: 'center', value: '' }
        ],
        headersDevisValid: [
          { text: 'Numero', align: 'center', sortable: true, value: '' },
          { text: 'Demandeur', align: 'center', value: '' },
          { text: 'Date', align: 'center', value: '' },
          { text: 'Actions', align: 'center', value: '' }
        ],
        searchRequest: '',
        searchDevis: '',
        modalValidation:false,
        idDemande:'',
        paginationRequestValid: {},
        paginationDevisValid: {},
        listRequestValid: [],
        listDevisValid: []
      }
    },
    computed: {
      pagesRequest () {
        return this.paginationRequestValid.rowsPerPage ? Math.ceil(this.listRequestValid.length / this.paginationRequestValid.rowsPerPage) : 0
      },
      pagesDevis () {
        return this.paginationDevisValid.rowsPerPage ? Math.ceil(this.listDevisValid.length / this.paginationDevisValid.rowsPerPage) : 0
      }
    },
    methods: {
      loadPage () {
        const loading = this.$loading({
          lock: true,
          text: 'Veuillez patientez ...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        setTimeout(() => {
          loading.close()
        }, 1000)
      },
      validRequest (item) {
        this.idDemande = item.id
        this.modalValidation = true
      },
      accepterDemande(){
        var formdata = new FormData()
        formdata.append('user', this.user.id)
        var url = this.domaine +  '/action-validate/' + this.idDemande;
        var request = new XMLHttpRequest()
        request.open('post', url)
        request.send(formdata)
        request.onreadystatechange = () => {
          let verif = JSON.parse(request.responseText)
          if (request.readyState === request.DONE) {
            if (request.status === 200) {
              if (verif[0].code === 1) {
                this.$notify({
                  title: 'LA DEMANDE A BIEN ETE VALIDEE',
                  message: 'VALIDATION réussie avec succès.',
                  type: 'success',
                  position: 'top-center'
                })
                this.modalValidation = false
                this.listRequestValid = verif[1]
              } else {
                this.modalValidation = true
                this.$message.error("une erreur s'est produit lors de la validation")
              }
            }
          }
        }
      },
      refuserDemande(){
        var formdata = new FormData()
        formdata.append('user', this.user.id)
        var url = this.domaine +  '/action-refuser/' + this.idDemande;
        var request = new XMLHttpRequest()
        request.open('post', url)
        request.send(formdata)
        request.onreadystatechange = () => {
          let verif = JSON.parse(request.responseText)
          if (request.readyState === request.DONE) {
            if (request.status === 200) {
              if (verif[0].code === 1) {
                this.$notify({
                  title: 'LA DEMANDE A BIEN ETE REFUSEE',
                  message: 'ACTION réussie avec succès.',
                  type: 'success',
                  position: 'top-center'
                })
                this.modalValidation = false
                this.listRequestValid = verif[1]
              } else {
                this.modalValidation = true
                this.$message.error("une erreur s'est produit lors de la validation")
              }
            }
          }
        }
      },
      validDevis (item) {
        this.idDemande = item.id
      },
      loadRequest () {
        let url = this.domaine +  '/request-to-validate/' + this.user.id;
        this.$http.get(url).then(response => {
          if (response.body) {
            this.listRequestValid = response.body
          }
        })
      },
      loadDevis () {
        let url = this.domaine +  '/devis-to-validate/' + this.user.id;
        this.$http.get(url).then(response => {
          if (response.body) {
            this.listDevisValid = response.body
          }
        })
      },
    },
    mounted () {
      this.loadPage()
      this.loadRequest()
      this.loadDevis()
    }
  };
</script>




// WEBPACK FOOTER //
// src/components/Validation.vue